import Base from "./base"
import Vue from "vue"

export default class BeforeApiExec extends Base {
  constructor(Vue, store) {
    super("before-api-exec", Vue, store)
  }

  async before(to, from, next) {
    console.log("before-api-exec")

    let event = this.store.getters["event/event"]
    const slug = to.params.slug
    const $moment = Vue.prototype.$moment

    if (_.isNull(slug)) {
      next({name: "NotFound"})
      return
    }

    // イベント情報がないかイベントのslugが一致しない場合は
    if (!event || event.slug !== slug) {
      await this.store.dispatch("event/getEvent", slug)
      event = this.store.getters["event/event"]
    }

    if (!event) {
      next({name: "NotFound"})
      return
    }

    // adminでログインしていない場合
    if (!this.store.getters["auth/isAdmin"]) {
      // イベントが非公開の時
      if (!event.is_published) {
        next({name: "NotFound"})
        return
        // イベントが公開中の時
      } else {
        const toDay = $moment().format("Y-MM-DD")
        const currentDateTime = $moment().format("Y-MM-DD HH:mm:ss")
        // 今日の日付に変換
        const toDayObject = _.pick($moment().toObject(), ["years", "months", "date"])
        const openAt = $moment(event.open_at).set(toDayObject)
        const closeAt = $moment(event.close_at).set(toDayObject)

        // 無期限開催でない かつ 開催中じゃない
        if (
          !event.is_publish_unlimited &&
          (!$moment(toDay).isBetween(event.start_date, event.end_date, null, "[]") ||
            !$moment(currentDateTime).isBetween(openAt, closeAt, "minutes", "[]"))
        ) {
          next({name: "NotFound"})
          return
        }
      }
    }

    const fromRouteName = from.name
    const toRouteName = to.name

    // ホール情報がなく、ログイン画面以外のルーティングへのアクセスだった場合
    if (!this.store.getters["hall/all"].length && (!_.includes(fromRouteName, "Login") || !_.includes(toRouteName, "Login"))) {
      await this.store.dispatch("hall/getHalls", slug)
    }

    const defaultHall = this.store.getters["hall/mainOrFirst"]
    // デフォルトホールが取得出来なかった(ホールが1つもなかった場合)
    if (_.isEmpty(defaultHall)) {
      next({name: "NotFound"})
      return
    }

    // メインホールがあり、TOPへ遷移する場合
    if (defaultHall.id && (_.includes(fromRouteName, "Top") || _.includes(toRouteName, "Top"))) {
      next({name: "Hall", params: {slug: slug, hallSlug: defaultHall.slug}})
      return
    }

    // ルーム情報がない状態でルームに直接アクセス遷移する場合
    if (_.includes(["YRoom", "YRoomEntry", "TRoom"], toRouteName) && !this.store.getters["room/all"].length) {
      await this.store.dispatch("room/getRooms", slug)
    }

    next()
  }
}
